/**
 * Gold botanical flourishes — the user's own gold-tinted line-art PNGs
 * with transparent backgrounds. No CSS filters needed — they render
 * beautifully on light OR dark backgrounds as-is. Decorative only
 * (aria-hidden), positioned absolutely, non-interactive.
 */

const FLOWERS = {
  orchid:    "https://customer-assets-cm19k8pv.emergentagent.net/job_bride-groom-hub-75/artifacts/gabpe1qe_orchid_reference_style.png",
  dahlia:    "https://customer-assets-cm19k8pv.emergentagent.net/job_bride-groom-hub-75/artifacts/rqdikjz3_dahlia_reference_style.png",
  calla:     "https://customer-assets-cm19k8pv.emergentagent.net/job_bride-groom-hub-75/artifacts/qu22fqyt_calla_lily_reference_style.png",
  hydrangea: "https://customer-assets-cm19k8pv.emergentagent.net/job_bride-groom-hub-75/artifacts/u69c51y1_hydrangea_reference_style.png",
  rose:      "https://customer-assets-cm19k8pv.emergentagent.net/job_bride-groom-hub-75/artifacts/1mdsgjc5_roos-kuldne-labipaistev-v2.png",
};

// On dark backgrounds we brighten slightly so the gold really glows.
const DARK_BOOST = {
  filter:
    "brightness(1.35) saturate(1.15) drop-shadow(0 0 6px rgba(255,220,140,0.35))",
};

// On light backgrounds the pale gold can vanish — darken + enrich the tone and
// stack two tight drop-shadows to make the strokes read a couple pixels thicker.
const LIGHT_BOOST = {
  filter:
    "brightness(0.7) saturate(1.55) contrast(1.3) drop-shadow(0 0 0.6px rgba(120,80,15,0.95)) drop-shadow(0 0 1.4px rgba(170,115,35,0.6))",
};

const FlowerImage = ({ src, className = "", opacity = 1, variant = "light" }) => (
  <img
    src={src}
    alt=""
    aria-hidden
    loading="lazy"
    draggable={false}
    className={`pointer-events-none select-none ${className}`}
    style={{
      opacity,
      ...(variant === "dark" ? DARK_BOOST : LIGHT_BOOST),
    }}
  />
);

export const OrchidFlourish = ({ className = "", opacity = 1, variant = "light" }) => (
  <FlowerImage src={FLOWERS.orchid} className={className} opacity={opacity} variant={variant} />
);

export const DahliaFlourish = ({ className = "", opacity = 1, variant = "light" }) => (
  <FlowerImage src={FLOWERS.dahlia} className={className} opacity={opacity} variant={variant} />
);

export const CallaLilyFlourish = ({ className = "", opacity = 1, variant = "light" }) => (
  <FlowerImage src={FLOWERS.calla} className={className} opacity={opacity} variant={variant} />
);

export const HydrangeaFlourish = ({ className = "", opacity = 1, variant = "light" }) => (
  <FlowerImage src={FLOWERS.hydrangea} className={className} opacity={opacity} variant={variant} />
);

// Rose now uses a proper transparent PNG (v2) — no blend-mode tricks needed.
// A gentle "brightness(1.05) contrast(0.92)" filter softens the linework by ~1px,
// giving a lighter, more delicate feel per user's request.
export const RoseFlourish = ({ className = "", opacity = 1, variant = "light" }) => (
  <img
    src={FLOWERS.rose}
    alt=""
    aria-hidden
    loading="lazy"
    draggable={false}
    className={`pointer-events-none select-none ${className}`}
    style={{
      opacity,
      filter:
        variant === "dark"
          ? "brightness(1.15) contrast(0.9) drop-shadow(0 0 8px rgba(255,205,120,0.35))"
          : "brightness(1.08) contrast(0.9)",
    }}
  />
);
